"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Detail = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var hsMySpecialProduct_1 = require("../../model/hsMySpecialProduct");
var service_1 = require("../../../library/base/service");
var Detail = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(Detail, _super);
    function Detail() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '特约认购产品详情接口';
        _this.code = '105033';
        _this.desc = '特约认购产品详情接口';
        _this.requestParams = new hsMySpecialProduct_1.DetailRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return Detail;
}(service_1.BaseService));
exports.Detail = Detail;
//# sourceMappingURL=detail.js.map